// TODO: does not belong in constants, move it to config
export default {
  UserStatus: {
    Investor: 'i',
    Signup: 's',
    Member: 'm',
  }
};
